import React from "react";

const PersonalDataConsent = () => (
  <table className="normalPadded" style={{ borderCollapse: "collapse", width: "100%" }}>
    <tbody>
      <tr>
        <td style={{ paddingLeft: 0 }} colSpan={11}>
          <div
            style={{
              fontWeight: "bold",
              paddingTop: 10,
              paddingBottom: 10,
            }}
          >
            (D) PERSONAL DATA CONSENT(S)
          </div>
          <div style={{ paddingBottom: 10 }}>
            I/We consent to Singapore Life Ltd. (“Singlife”) (and Singlife related group of
            companies) collecting, using and/or disclosing my/our personal data for the processing
            of the above transaction and such other purposes ancillary or related to the
            administering of the policy(ies), account(s) and/or managing my/our relationship with
            Singlife.
            <br />
            <br />
            I/We also consent to Singlife (and Singlife related group of companies) transferring
            my/our personal data to Singlife (and Singlife related group of companies) and their
            respective third party service providers, reinsurers, suppliers or intermediaries,
            whether located in Singapore or elsewhere, for the above purposes.
            <br />
            <br />
            I/We have read and understood Singlife’s Data Protection Notice which may be found at&nbsp;
             <a href="https://singlife.com/en/pdpa" target="_blank" rel="noopener noreferrer">
             <span className="printcontrolLink">www.singlife.com/pdpa</span>
            </a>
            . Singlife’s Data Protection Notice may be updated from time to time without notice.
            I/We am/are aware that I/we should visit your website regularly to ensure that I/we
            am/are well informed of the updates.
          </div>
        </td>
      </tr>
    </tbody>
  </table>
);

export default PersonalDataConsent;



// WEBPACK FOOTER //
// ./components/employee/hdf-forms/Aviva/SINGLIFEHD202308/PersonalDataConsent.js